import React, { useCallback, useEffect, useState } from "react";
import { Loader } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { IErrorResponse, IProxyUser } from "../interfaces/Global";
import BCMenuBar from "../ui/BCMenuBar";
import BCMessage from "../ui/BCMessage";
import BCButton from "../ui/BCButton";
import BCTable from "../ui/BCTable";
import { convertToDollar, formatDataProperties, handleErrorResponse } from "../../Helpers";
import { getMockPendingApprovalInfolist } from "../../api/mock/MockBorrowerApi";
import { getPendingApprovalInfolist } from "../../api/BorrowerApi";
import { IPendingApprovalObj, IPendingApprovalView } from "../interfaces/Borrower";
import BWSearchBox from "./BWSearchBox";
import BWExportButton from "./BWExportButton";
import BCEmptyState from "../ui/BCEmptyState";
import { FeatureFlags } from "../constants/LocalServerConstants";
import { handleApiPromise } from "../../helpers/GlobalHelper";

interface IBWPendingApprovalProps {
  isGreaterThanMobile: boolean;
  isGreaterThanTablet: boolean;
  isSidebar: boolean;
  isMessage: boolean;
  setIsMessage: React.Dispatch<React.SetStateAction<boolean>>;
  errorResponse: IErrorResponse | undefined; 
  setErrorResponse: React.Dispatch<React.SetStateAction<IErrorResponse | undefined>> 
  proxyUser: IProxyUser | undefined;
}

const BWPendingApproval = ({...props} : IBWPendingApprovalProps) => {
  const [isFirstLoad, setIsFirstLoad] = useState(true as boolean);
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [pendingApprovalInfoData, setPendingApprovalInfoData] = useState([] as IPendingApprovalObj[]);
  
  const history = useHistory();
  const handleError = useCallback(() => {
      history.push("/error");
  }, [history]);

  const ApproveButton = () => {
    const handleApprove = () => console.log("Clicked on Approve button"); // TODO: Approve Button functionality
    return (
      <BCButton handleOnClick={handleApprove}>Approve</BCButton>
    );
  };

  const convertToTableFormat = (approvals) => {
    const result = [] as IPendingApprovalView[];
    approvals.forEach((approval) => {
      if (approval.vendorName !== null) {
        result.push({
          "vendorName": approval.vendorName,
          "referenceNo": approval.referenceNo,
          "drawRequestAmount": convertToDollar(approval.drawRequestAmount),
          "address": approval.address,
          "city": approval.city,
          "state": approval.state,
          "zip": approval.zip,
          "requiresApprovalForPayment": approval.requiresApprovalForPayment ? "Yes" : "No",
          "paidToVendor": approval.paidToVendor ? "Yes" : "No",
          "email": approval.email,
          "approvedAmount": convertToDollar(approval.approvedAmount),
          "drawName": approval.drawName,
          "propertyAddress": approval.propertyAddress,
        });
      }
    });

    return formatDataProperties(result);
  };

  useEffect(() => {
    const getPendingApproalInfoAysnc = async () => {
      const data = await handleApiPromise(
        () => getPendingApprovalInfolist(props.proxyUser && props.proxyUser.id),
        () => getMockPendingApprovalInfolist(),
        (response) => handleErrorResponse(response, props.setIsMessage, props.setErrorResponse)
      ) || [];

      const pendingApprovalViews = [] as IPendingApprovalObj[];
      data.forEach((pendingApproalInfolistItem) => {
        pendingApprovalViews.push(pendingApproalInfolistItem as IPendingApprovalObj);
      });
      
      setPendingApprovalInfoData(pendingApprovalViews);
      setIsLoading(false);
    };

    if (isFirstLoad) {
      getPendingApproalInfoAysnc();
    }
  }, [props.setIsMessage, props.setErrorResponse, setIsLoading, handleError, props.proxyUser, isFirstLoad]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, []);

  return (
    <div className={(props.isGreaterThanTablet && props.isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
    {isLoading ? <Loader active inline="centered" size="big" /> : <React.Fragment>
        <BCMessage
            animation={"fly down"}
            duration={750}
            visible={props.isMessage}
            transitionOnMount
            styles="full-width"
            onDismiss={() => props.setIsMessage(false)}
            errorResponse={props.errorResponse}
        />
        <BCMenuBar 
            isGreaterThanMobile={props.isGreaterThanMobile}
            leftChildren={[<BWExportButton />, <ApproveButton />]}
            rightChildren={[<BWSearchBox />]}
        />
        {pendingApprovalInfoData.length > 0 ? <BCTable 
            data={convertToTableFormat(pendingApprovalInfoData)}
            selectable
            overflowX
            overflowY
            dataSingleLine
            sortable={["Vendor Name", "Reference No", "Draw Request Amount", "Address", "City", "State", "Draw Name", "Property Address", "Approved Amount"]}
            pagination={25}
        /> : <BCEmptyState
          emptyStateClass="borrower-portal-empty-state"
          icon="table"
          text="No pending approval information to display"
        />}
      </React.Fragment>}
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <button onClick={() => console.log(pendingApprovalInfoData)}>pendingApprovalInfoData</button>
      </React.Fragment>}
    </div>
  );
};
  
export default BWPendingApproval;